export default __webpack_public_path__ + "static/media/rocket_anim_4.54157170.png";